import React from "react";
import s from "./default-days.module.scss";

const DefaultDays = (props) => {

    const setPeriodDay = (period) => {
        props.callback(period)
    }

    return (
        <div className={s.DefaultDays}>
            <button disabled={props.isFetching} className={s.DefaultDaysButton} onClick={setPeriodDay.bind(this, 'today')}>
                <span>{props.getValue('TODAY_2')}<div></div></span>
            </button>

                <div className={s.Separator}><div></div></div>

            <button disabled={props.isFetching} className={s.DefaultDaysButton} onClick={setPeriodDay.bind(this, 'week')}>
                <span>{props.getValue('WEEK_2')}</span>
            </button>

                <div className={s.Separator}><div></div></div>

            <button disabled={props.isFetching} className={s.DefaultDaysButton} onClick={setPeriodDay.bind(this, 'month')}>
                <span>{props.getValue('MONTH')}</span>
            </button>

                <div className={s.Separator}><div></div></div>

            <button disabled={props.isFetching} className={s.DefaultDaysButton} onClick={setPeriodDay.bind(this, 'year')}>
                <span>{props.getValue('YEAR')}</span>
            </button>
        </div>
    )
}

export default DefaultDays;